import SonicOfferUserMeta, {
  SonicOfferUserMetaData,
} from "./SonicOfferUserMeta";
import { SonicTermData } from "./SonicTerm";

export interface SonicOfferMetaData {
  from: SonicOfferUserMetaData;
  to: string;
  content_status: string;
  recipient: SonicOfferUserMetaData;
}

export default class SonicOfferMeta implements SonicOfferMetaData {
  from: SonicOfferUserMetaData;
  to: string;
  content_status: string;
  recipient: SonicOfferUserMetaData;

  constructor(
    from_name: string,
    to: string,
    content_status: string,
    recipient_name: string,
    from_email?: string,
    from_full_name?: string,
    from_roles?: Array<string>,
    from_school?: SonicTermData,
    recipient_email?: string,
    recipient_full_name?: string,
    recipient_roles?: Array<string>
  ) {
    this.from = new SonicOfferUserMeta(
      from_name,
      from_email,
      from_full_name,
      from_roles,
      from_school
    );
    this.to = to;
    this.content_status = content_status;
    this.recipient = new SonicOfferUserMeta(
      recipient_name,
      recipient_email,
      recipient_full_name,
      recipient_roles,
      undefined
    );
  }

  static parseFromAPIResponse(item: any) {
    return new SonicOfferMeta(
      item.from?.name,
      item.to,
      item.content_status,
      item.recipient?.name,
      item.from?.email,
      item.from?.full_name,
      item.from?.roles,
      item.from?.school,
      item.recipient?.email,
      item.recipient?.full_name,
      item.recipient?.roles
    );
  }
}
